import { PartialSetter } from '@pages/Products/Heading.types';
import { SetState } from '@pages/Organization/utils/onOrgNameSubmit';

export function makePartialSetter<U>(
  _setFilter: SetState<U>,
): PartialSetter<U> {
  return value => {
    _setFilter(_value => {
      let newValue = _value;
      if (value instanceof Function) {
        newValue = value(_value) as U;
      } else {
        newValue = value as U;
      }
      return { ..._value, ...newValue };
    });
  };
}
